// extracted by mini-css-extract-plugin
export default {"content":"TextContent_content__Aif3O"};